import { render, staticRenderFns } from "./intentNodeComponent.vue?vue&type=template&id=8481f48a"
import script from "./intentNodeComponent.vue?vue&type=script&lang=js"
export * from "./intentNodeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports